import { render, staticRenderFns } from "./ResetPasswordComponent.vue?vue&type=template&id=6b8be348"
import script from "./ResetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ResetPasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordComponent.vue?vue&type=style&index=0&id=6b8be348&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports